import { BOARD_TYPE } from '../../../constants/boardConstants';
var isBoard = function (boardType) {
    return (boardType.toUpperCase() === BOARD_TYPE.MAIN ||
        boardType.toUpperCase() === BOARD_TYPE.VOD ||
        boardType.toUpperCase() === BOARD_TYPE.MOVIE ||
        boardType.toUpperCase() === BOARD_TYPE.PARAMOUNT ||
        boardType.toUpperCase() === BOARD_TYPE.HISTORY);
};
export default isBoard;
